import React from 'react';
import { Input } from 'flos-react-cvi';
import './insurance-number-field.css';

export const InsuranceNumberField = ({ insuranceType, label, value, dialogLabel, onChange }) => {
    const [isDialogShown, setIsDialogShown] = React.useState(false);

    function onFocus() {
        setIsDialogShown(true);
    }

    function onBlur() {
        setIsDialogShown(false);
    }

    return (
        <div className="form-group" style={{ position: 'relative' }}>
            <label className="control-label" htmlFor={`${insuranceType}CurrentNumber`}>
                {label}
            </label>
            <Input
                id={`${insuranceType}CurrentNumber`}
                value={value}
                onChangeValue={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                data-testid={`${insuranceType}CurrentNumber`}
            />
            <div
                className="infobox-current-insurance-number dialog small"
                style={{ display: isDialogShown ? 'block' : 'none' }}
            >
                <div className="dialog-content">
                    <p>{dialogLabel}</p>
                </div>
            </div>
        </div>
    );
};
